/* eslint-disable import/prefer-default-export */
import { gql } from "@apollo/client";

export const ANSWER_ENCOUNTER = gql`
  mutation AnswerEncounter(
    $selectedChoices: JSONString
    $userId: Int
    $encounterId: Int!
    $eventLocation: String
  ) {
    answerEncounter(
      selectedChoices: $selectedChoices
      userId: $userId
      encounterId: $encounterId
      eventLocation: $eventLocation
    ) {
      encounter {
        id
        hashId
        title
        description
        thumbnail
        documentSet {
          id
          title
          body
          metadata
        }
        encounterlogicSet {
          id
          question {
            id
            text
            votes
            choiceSet {
              id
              text
              correctAnswer
              votes
            }
          }
          explanation {
            id
          }
        }
      }
    }
  }
`;

export const ANSWER_CLINIC_ENCOUNTER = gql`
  mutation AnswerClinicEncounter(
    $selectedChoices: JSONString
    $userId: Int
    $encounterId: Int!
    $eventLocation: String
  ) {
    answerClinicEncounter(
      selectedChoices: $selectedChoices
      userId: $userId
      encounterId: $encounterId
      eventLocation: $eventLocation
    ) {
      encounter {
        id
        hashId
        title
        description
        thumbnail
        documentSet {
          id
          title
          body
          metadata
        }
        encounterlogicSet {
          id
          question {
            id
            text
            votes
            choiceSet {
              id
              text
              correctAnswer
              votes
            }
          }
          explanation {
            id
          }
        }
      }
    }
  }
`;
